import {
  type PricingExperimentOptOutResponse,
  rbcAccountsApi,
} from "@b2bportal/rbc-accounts-api";
import { axiosInstance } from "@hopper-b2b/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * The user leaves the Grid V2 test for good. The BFF records it on the user
 * (idempotent, no opt back in) and prices every later search on V1. The
 * response carries the properties the opt-out tracking event must merge.
 *
 * The caller re-shops after this resolves: trip detail and checkout re-read
 * the flag, so a trip priced on V2 before the opt-out can fail on the V1 path.
 */
export const optOutOfGridV2 = createAsyncThunk<
  PricingExperimentOptOutResponse,
  void,
  { rejectValue: string }
>("gridV2/optOut", async (_, thunkAPI) => {
  try {
    const response =
      await rbcAccountsApi(
        axiosInstance
      ).apiV0AccountsPricingExperimentOptOutPost();
    return response.data;
  } catch (error) {
    console.error("optOutOfGridV2 threw", { error });
    return thunkAPI.rejectWithValue(
      error instanceof Error ? error.message : String(error)
    );
  }
});
